import React from 'react';

export default function Image({ Path, Class }) {
  return <img src={typeof Path === 'string' ? Path : (Path?.src || Path)} className={Class} alt="" />;
}
